import { CommonModule } from '@angular/common';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input} from '@angular/core';
import { HotelBeachType } from 'src/app/models';
import { environment } from '../../../../../environments/environment';
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../../../config/hotel-tours-list-page.config";

export interface HotelService {
  name: string;
  icon: string;
}

@Component({
  selector: 'app-hotel-services',
  templateUrl: './hotel-services.component.html',
  styleUrls: environment.mobile ? ['./hotel-services.component.mobile.scss'] : ['./hotel-services.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class HotelServicesComponent {
  #tour: any;
  messages: any = {};

  public services: HotelService[] = [];

  public readonly isDesktop = !environment.mobile;

  @Input() set tour(value: any) {
    this.#tour = value;
    this.populateBeachServices();
  }

  constructor(
    @Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig
  ) {
    this.messages = this.hotelToursPageConfig.translates.hotelServices;
  }

  private populateBeachServices() {
    const services: HotelService[] = [];

    if (this.#tour.seaLine) {
      services.push({
        name: `${this.#tour.seaLine}${this.messages.seaLine}`,
        icon: 'icon--beach-line',
      });
    }

    if (this.#tour.beachType) {
      let service: HotelService;
      switch (this.#tour.beachType) {
        case HotelBeachType.SANDY:
          service = {
            name: this.messages.sand,
            icon: 'icon--sand',
          };
          break;

        case HotelBeachType.PEBBLE:
          service = {
            name: this.messages.pebbles,
            icon: 'icon--pebbles',
          };
          break;

        case HotelBeachType.SANDY_PEBBLE:
          service = {
            name: this.messages.sandPebbles,
            icon: 'icon--sand-pebbles',
          };
          break;
      }
      if (service) {
        services.push(service);
      }
    }

    if (this.#tour.hotelServices?.includes('Аквапарк')) {
      services.push({
        name: this.messages.aquapark,
        icon: 'icon--aquapark',
      });
    }

    this.services = services;
  }
}
